<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Weapons of Our Warfare</title>
<div class="image">
<span epub:type="pagebreak" id="page_i" title="i">
<p class="ser"><img alt="Image" src="images/img-2-1.jpg"/></p>
</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?5942dda1